export default "/assets/images/performance-hero.62d234e7fc054cf4.webp";